import { GraphQLClient } from "graphql-request";

import Config from "~/config";
import offlineRequestMiddleware from "~/helpers/offline/offlineRequestMiddleware";
import getHeaders from "~/services/graphqlHeaders";

const client = new GraphQLClient(Config.endpoint, {
	credentials: "omit",
	headers: () => getHeaders(),
	mode: "cors",
	requestMiddleware: offlineRequestMiddleware
});

export default client;
